import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface OnboardingProgressState {
  stepIndex: number;
}

const initialState: OnboardingProgressState = {
  stepIndex: 0,
};

const onboardingProgressSlice = createSlice({
  name: 'onboardingProgress',
  initialState,
  reducers: {
    setOnboardingStep(state, action: PayloadAction<number>) {
      state.stepIndex = action.payload;
    },
    advanceOnboardingStep(state, action: PayloadAction<number>) {
      if (action.payload > state.stepIndex) {
        state.stepIndex = action.payload;
      }
    },
  },
});

export const { setOnboardingStep, advanceOnboardingStep } = onboardingProgressSlice.actions;

type OnboardingProgressRootState = { onboardingProgress: OnboardingProgressState };

export const selectOnboardingStepIndex = (state: OnboardingProgressRootState) =>
  state.onboardingProgress.stepIndex;

export default onboardingProgressSlice.reducer;
